angular.module('unica_media_upload.media_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// MEDIA
		.state('app.media_upload', {
			url: '/media-upload',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/media-upload/templates/media-upload.html',
					controller: 'MediaUploadBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// MEDIA LIST
			.state('app.media_upload.list', {
				url: '/list/:event_id',
				views: {
					'mediaUploadContent': {
						templateUrl: './modules/media-upload/templates/list.html',
						controller: 'MediaUploadListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Lista Media',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
					}
				}
			});


});

